/** A paragraph holding only a label: text ending in a colon, then blank space. */
const LABEL_PARAGRAPH =
    /<p(\s[^>]*)?>((?:(?!<\/?p[\s>])[\s\S])*?:)(?:\s|&nbsp;)*<\/p>/gi;

/**
 * Tags the paragraphs in a supplier's spec HTML that only name what follows
 * ("FINISH:", then the finish on its own line or list) with `data-spec-label`,
 * so a label can sit tight against its value while the groups stay apart.
 * Paragraphs carrying a value after their colon ("MAX. PRESSURE: 500kPa") are
 * left as they are.
 */
export const markSpecLabels = (html: string): string =>
    html.replace(
        LABEL_PARAGRAPH,
        (_match, attributes: string | undefined, text: string) =>
            `<p${attributes ?? ''} data-spec-label>${text}</p>`,
    );
